import React from 'react'
import Layout from '../../common/Layout'
import ConfigureRateLimiterContainer from '../../features/AdministrationPortal/Configurations/ConfigureRateLimiter/ConfigureRateLimiterContainer'
import 'bootstrap/dist/css/bootstrap.min.css';

export default {
  path: '/administration/configureRateLimiter',
  async action () {
    return {
      title: 'Configure Rate Limiter',
      component: <Layout containerWell>
        <ConfigureRateLimiterContainer />
      </Layout>
    }
  }
}
